import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJsonComponent } from './simple-icons-json.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJsonComponent ],
    exports:      [ SimpleIconsJsonComponent ],
    bootstrap:    []
})
export class SimpleIconsJsonModule {}
